//import * as shape from 'd3-shape';
//import * as d3 from 'd3';
//import 'd3-transition';
import { ActivatedRoute, Router } from '@angular/router';
import { CdkDragDrop, CdkDragEnd, moveItemInArray } from '@angular/cdk/drag-drop';
import { ChangeDetectorRef, Component, ElementRef, HostListener, NgZone, OnInit, Renderer2, ViewChild } from '@angular/core';
import { ClusterNode, Edge, GraphComponent, Layout, Node } from '@swimlane/ngx-graph';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { AppDetailsModalComponent } from '../app-details-modal/app-details-modal.component';
import { DndDropEvent } from 'ngx-drag-drop';
import { Location } from '@angular/common';
import { MainService } from '../services/main.service';
import { MatDialog } from '@angular/material/dialog';
import { MatMenu } from '@angular/material/menu';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2'
import { take } from 'rxjs';

@Component({
  selector: 'app-new-data-eng',
  templateUrl: './new-data-eng.component.html',
  styleUrls: ['./new-data-eng.component.scss']
})
export class NewDataEngComponent implements OnInit {
  nodes = [

  ];
  di_tcd_obj = {
    "TR": "Term",
    "LR": "Entity",
    "LF": "Data View",
    "DS": "Data Store",
    "PF": "Data File"
  }
  //curve = shape.curveLinear;
  selectedtype = null;
  layoutSettings = {
    orientation: 'LR',
    edgePadding: 250,
    rankPadding: 400,
    nodePadding: 300,
    multigraph: true,
    compound: true,


  };
  edges: Edge[] = [];
  layout: String | Layout = 'dagre';
  hierarchicalData = []
  appnode = {}
  cdvalue = {
    TR: 'Business Term',
    APP: 'application',
    PF: 'Physical File',
    LF: 'Logical File',
    LR: 'Logical Record',
    "DS": "Data Store"

  }
  config
  constructor(private renderer: Renderer2, private fb: FormBuilder, private spinner: NgxSpinnerService, private location: Location, public main: MainService, public dialog: MatDialog, private cdr: ChangeDetectorRef, private zone: NgZone, private route: ActivatedRoute, private router: Router) {
    this.scrollToTop();

  }
  async ngOnInit() {
    this.spinner.show();
    this.renderer.listen('document', 'mouseup', (event) => this.onGlobalMouseUp(event));

    this.relationshipForm = this.fb.group({
      primaryKey: ['', Validators.required],
      relationshipType: ['', Validators.required],
      foreignKey: ['', Validators.required]
    });

    this.route.queryParams.pipe(take(1)).subscribe(async (params) => {
      try {
        await this.reset();

        if (params['id']) {
          const decoded = window.atob(params['id']);
          const parsed = JSON.parse(decoded);
          this.config = parsed.app;

          await this.constructappnode(this.config);
          this.pfflag = false;


          await this.getAllDiTcd();
          await this.getAssociations();


          await this.getAllApplications();

          await this.showAssociations();
        }
      } catch (err) {
        console.error('Error initializing page', err);
      } finally {
        this.spinner.hide();
      }
    });
  }

  showDialog = false;
  termId: string = '';
  termName: string = '';
  termType: string = '';
  app_id
  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  async constructappnode(app) {
    this.appnode = { id: app['cl_cd'], cd: app['cl_cd'], cl_id: app['cl_id'], label: app['cl_val'], type: 'application', referData: app }
  }
  addTerm(result): void {


    // this.main.addTermToEmployeeTable(result);
    this.termId = '';
    this.termName = '';
    this.termType = '';

    this.showDialog = false;
  }
  async reset() {
    this.hierarchicalData = []
    this.nodes = []
    this.edges = []
  }
  allapps = []
  async getAllApplications() {
    await this.reset()
    let resp = await this.main.getAllApplications()
    if (resp['error'] == false) {
      this.app_id = resp['data'][0]['di_id']
      let clarr = resp['data'][0]['cl']
      this.allapps = clarr.filter(ele => ele['cl_id'] != this.config['cl_id']);
      ////console.log(this.config['cl_id']);

      const filteredArray = clarr.filter(ele => ele['cl_id'] === this.config['cl_id']);

      this.hierarchicalData = filteredArray
      ////console.log(this.hierarchicalData);

      //await this.getLFDtls()


      await this.constructData();

    }
    else {
    }
  }
  clusters: ClusterNode[] = []
  async constructData() {
    for (const application of this.hierarchicalData) {
      await this.showFiles({ cl_id: application.cl_id });
    }
  }
  async getLFDtls(): Promise<void> {

    for (const application of this.hierarchicalData ?? []) {

      const dataFiles = application?.data_files;
      if (!Array.isArray(dataFiles)) continue;

      for (const file of dataFiles) {

        const lfTechNm = file?.di_tcd_json?.default_lf?.di_tech_nm;
        if (!lfTechNm) continue;

        const lfReq = {
          di_tech_nm: lfTechNm,
          di_tcd: 'LF'
        };

        const lfResp = await this.main.getdtls(lfReq);

        if (lfResp?.error) {
          Swal.fire('Error!', 'LF fetch failed', 'error');
          continue;
        }

        file.logical_file = lfResp.data ?? [];

        // 🔥 Now fetch logical records
        for (const lf of file.logical_file) {

          const lrTechNm = lf?.di_tcd_json?.default_lr?.di_tech_nm;
          if (!lrTechNm) continue;

          const lrReq = {
            di_tech_nm: lrTechNm,
            di_tcd: 'LR'
          };

          const lrResp = await this.main.getdtls(lrReq);

          if (!lrResp?.error) {
            lf.logical_record = lrResp.data ?? [];
          }
        }
      }
    }
  }

  async empty(type, data) {
    for (let i = this.nodes.length - 1; i >= 0; i--) {
      if (this.nodes[i].type === type) {
        this.nodes.splice(i, 1);
      }
    }
    this.nodes = [...this.nodes];
    for (let i = this.edges.length - 1; i >= 0; i--) {
      if (this.edges[i].data === data) {
        this.edges.splice(i, 1);
      }
    }
    this.edges = [...this.edges];
  }
  ascflag = false;
  pfs = []
  deepCopiedClDi = []
  @ViewChild('toggleElement', { static: false }) toggleElement: MatSlideToggle;
  async showFiles(node) {
    this.pfs = [];


    await this.empty('Business Term', 'PFTOTR');
    await this.empty('Physical File', 'APPTOFILE');
    // await this.onCheckboxChange({ checked: false });

    if (this.toggleElement) {
      this.toggleElement.checked = false;
    }

    this.ascflag = false;
    this.deepCopiedClDi = []

    let where = {
      "and": [
        {
          "cl_id": {
            "=": node.cl_id
          }
        }
      ]
    };

    let req_obj = {
      pf_path: 'dd',
      pf_name: 'cl',
      app_cd: 'DD',
      filter: where,
      "include": {
        "all": true
      }
    };

    try {

      const resp = await this.main.getListData(req_obj);
      console.log(resp);

      if (!resp.error) {

        for (const application of this.hierarchicalData) {
          if (application.cl_id == node.cl_id) {
            application.data_files = resp['data'][0]['clDi'];
            this.deepCopiedClDi = resp['data'][0]['clDi'];

            if (application.data_files.length === 0) {
              await Swal.fire({
                icon: 'info',
                title: 'No Physical Files Present',
                text: 'There are no Physical Files Present in this App. Please Add the Physical Files',
                confirmButtonText: 'OK'
              });
            }

            await this.findDistinctDiid(application.data_files);
            console.log(this.PFSArr);

            // Add elements to data_files
            // this.PFSArr.forEach(ele => {
            //   application.data_files.push(ele);
            // });
            for (const ele of this.PFSArr) {
              application.data_files.push(ele);
            }

          }
        }
      } else {
        await Swal.fire('Error!', 'error', 'error');
      }
    } catch (error) {
      await Swal.fire('Error!', 'Failed to get data.', 'error');
    }

    // Set the data asynchronously
    await this.setData(node);

    // Uncomment if needed to show associations
    // await this.showAssociations();
  }

  async setData(node: any) {
    this.pfs = []
    this.nodes = []
    for (const application of this.hierarchicalData) {
      if (application.cl_id == node.cl_id) {
        // await this.findDistinctDiid(application.data_files)


        for (const physicalFile of application.data_files) {
          // await works here


          this.pfs.push(physicalFile)

          this.nodes.push({ id: physicalFile.di_id, cd: physicalFile.di_tech_nm, label: physicalFile.di_bus_nm, type: 'Physical File', referData: physicalFile, showTerms: false });
          // this.nodes = [...this.nodes]
        };
      }
    };
    await this.getLFDtls()
    await Promise.all(
      this.nodes.map(node => this.toggleTermsVisibility(node))
    );

    this.nodes = [...this.nodes];
    this.ascflag = true;
    // await this.onCheckboxChange({ checked: true })
  }
  distinctDIID = []
  async findDistinctDiid(pfarr: any) {
    this.distinctDIID = pfarr.map(ele => ele?.di_id)
    console.log(this.distinctDIID);
    await this.getMissingDiids()


  }
  pfId = {}
  pfnode = {}
  termarr = []
  async showTerms(node: any) {
    this.pfId = {};
    this.pfnode = {};

    await this.empty('Business Term', 'PFTOTR');

    for (const application of this.hierarchicalData ?? []) {

      const dataFiles = application?.data_files;
      if (!Array.isArray(dataFiles)) continue;

      for (const physicalFile of dataFiles) {

        if (physicalFile?.di_id !== node.id) continue;

        this.pfId = node.id;
        this.pfnode = node;

        const logicalFiles = physicalFile?.logical_file;
        if (!Array.isArray(logicalFiles)) return;

        for (const logicalFile of logicalFiles) {

          const req_obj = {
            di_tech_nm: logicalFile.di_tech_nm,
            di_tcd: 'LR'
          };

          const resp = await this.main.getdtls(req_obj);

          if (resp?.error) {
            Swal.fire('Error!', 'error', 'error');
            continue;
          }

          const logicalRecord = resp?.data?.[0];
          if (!logicalRecord?.objDi) continue;

          this.termarr = [];

          for (const term of logicalRecord.objDi) {
            this.termarr.push(term.di_id);

            this.nodes.push({
              id: `${term.di_id}-${term.di_tech_nm}`,
              label: term.di_bus_nm,
              type: 'Business Term',
              referData: term['1_dixdi'],
              mainData: term,
              techNm: term.di_tech_nm
            });

            this.edges.push({
              source: physicalFile.di_id,
              target: `${term.di_id}-${term.di_tech_nm}`,
              label: 'contains',
              data: 'PFTOTR'
            });
          }

          // trigger change detection once per LR
          this.nodes = [...this.nodes];
          this.edges = [...this.edges];
        }

        return; // PF found → stop looping
      }
    }
  }

  async showAssociations() {

    const nodeIds = new Set(this.nodes.map(node => node.id));


    const validEdges = this.ascarr.filter(edge =>
      nodeIds.has(edge.source) && nodeIds.has(edge.target)
    );


    this.edges = [...this.edges, ...validEdges];
    //  this.edges = [...this.edges]

    console.log(this.edges, 'edges');
  }
  async removeAssociations() {
    for (let i = this.edges.length - 1; i >= 0; i--) {
      if (this.edges[i].data === 'FILETOFILE') {
        this.edges.splice(i, 1);
      }
    }
    this.edges = [...this.edges];
  }

  ItemsArr = []
  async getData(obj) {
    try {
      let req_obj = {}
      if (obj['di_tcd'] == 'RL') {
        req_obj = { 'di_tcd': 'PF' };
      }
      else {
        req_obj = { 'di_tcd': obj['di_tcd'] };
      }

      let res = await this.main.getdata(req_obj);
      if (res['error'] === false) {
        if (res['data'].length > 0) {
          if (obj['di_tcd'] != 'PF' && obj['di_tcd'] != 'RL') {

            this.ItemsArr = res['data'];
            this.filteredItems = this.ItemsArr;
          }
          else if (obj['di_tcd'] == 'RL') {
            await this.filterPFsnotpartofapp(res['data'])
          }
          else {
            await this.filterPFs(res['data'])
          }
        }


      } else {
        throw new Error('Failed to fetch data from the API');
      }
    } catch (error) {
      //console.error('Error fetching data:', error);

    }
  }
  async filterPFs(data) {
    const req_obj = {
      pf_path: 'dd',
      pf_name: 'clxdi',
      app_cd: 'DD',
      filter: null
    };

    this.filteredItems = [];
    this.ItemsArr = [];

    for (const ele of data) {

      req_obj.filter = {
        and: [
          {
            obj_di_id: {
              '=': ele['di_id']
            }
          }
        ]
      };

      try {
        const resp = await this.main.getListData(req_obj);
        ////console.log(resp);

        if (!resp.error) {
          if (resp.data.length === 0) {
            this.ItemsArr.push(ele);
          }
        } else {
          Swal.fire('Error!', 'error', 'error');
        }

      } catch (error) {
        //console.error('Error', error);
        Swal.fire('Error!', 'Failed to get data.', 'error');
      }
    }

    this.filteredItems = this.ItemsArr;
  }

  async filterPFsnotpartofapp(data) {
    let req_obj = {
      pf_path: 'dd',
      pf_name: 'clxdi',
      app_cd: 'DD',
    }
    this.filteredItems = []
    this.ItemsArr = []
    console.log(this.deepCopiedClDi);

    this.ItemsArr = data.filter(obj1 => this.deepCopiedClDi.every(obj2 => obj1.di_id != obj2.di_id));
    this.filteredItems = this.ItemsArr;

  }

  @ViewChild('graph', { static: true }) graph: GraphComponent;
  onDragStart(event: DragEvent, item): void {
    ////console.log(item);

    const card = event.target as HTMLElement;
    const offsetX = event.clientX - card.getBoundingClientRect().left;
    const offsetY = event.clientY - card.getBoundingClientRect().top;
    event.dataTransfer?.setDragImage(card, offsetX, offsetY);
    card.style.opacity = '0.5';
    this.selectedItem = item;
  }
  onDragEnd(event: DragEvent): void {
    ////console.log(event);

    const card = event.target as HTMLElement;
    card.style.opacity = '1';
  }
  isDragging = false;

  onDragOver(event: DragEvent): void {
    event.preventDefault();
  }

  async onDrop(event: DragEvent) {
    event.preventDefault();
    ////console.log(event);
    const dropX = event.clientX;
    const dropY = event.clientY;

    let nodefound = false
    for (const node of this.nodes) {

      const nodeElement = document.getElementById(node.id);
      const nodeRect = nodeElement.getBoundingClientRect();
      const nodeX = nodeRect.left + window.scrollX;
      const nodeY = nodeRect.top + window.scrollY;


      if (dropX >= nodeX && dropX <= nodeX + nodeRect.width &&
        dropY >= nodeY && dropY <= nodeY + nodeRect.height) {
        ////console.log(event);

        ////console.log('Item dropped on node:', node);
        nodefound = true;
        await this.insertRecord(node)

        break;
      }
    }
    if (!nodefound && this.selectedItem['di_tcd'] == 'PF') {
      ////console.log('dropped item--->', event);
      await this.insertRecord(this.appnode)
    }
  }

  selectedItem: any
  showTermbox = false;
  async onSelect() {
    ////console.log(this.selectedItem);
    this.showTermbox = true;
  }
  async insertRecord(node) {
    ////console.log(node);
    let type = this.selectedItem['di_tcd']
    switch (type) {
      case 'TR': await this.insertTr(node)
        break;
      case 'PF': this.selectedtype === 'RL' ? await this.insertpfforrl(node) : await this.insertPf(node);
    }
  }
  async insertpfforrl(node: any) {
    // this.deepCopiedClDi.push(node)
    console.log(node, this.selectedItem);

    for (const application of this.hierarchicalData) {
      if (application.cl_id == this.appnode['cl_id']) {
        // await this.findDistinctDiid(application.data_files)
        application.data_files.push(this.selectedItem);
      }
    }

    await this.setData(this.appnode);
  }

  async insertTr(node): Promise<void> {
    ////console.log(node);

    for (const item of this.phytermsarr[node.id]) {
      if (item['di_id'] === this.selectedItem['di_id']) {
        Swal.fire('Info!', 'You cannot add this term..As this Term is already attached in this logical record', 'info');
        return;
      }
    }

    // ////console.log(node.referData?.logical_file[0]['logical_record'][0]['objDi'], this.selectedItem);
    const objDiArray = node['referData']['objDi'];
    let maxSeqNum = -1;
    //console.log(objDiArray);


    if (objDiArray) {
      for (let objDi of objDiArray) {
        let dixdiSeqNum = objDi['1_dd-dixdi']?.dixdi_seq_num;
        ////console.log(objDi['1_dixdi']?.dixdi_seq_num, 'objDi');

        if (dixdiSeqNum > maxSeqNum) {


          maxSeqNum = dixdiSeqNum;
        }
      }
    }

    //console.log('Maximum dixdi_seq_num:', maxSeqNum);
    let req_obj = {};
    req_obj['pf_path'] = 'dd';
    req_obj['pf_name'] = 'dixdi';
    req_obj['app_cd'] = 'DD';
    req_obj['columns'] = ['sub_di_id', 'obj_di_id', 'dixdi_tcd', 'dixdi_seq_num', 'dixdi_tcd_json'];
    req_obj['values'] = [node['id'], this.selectedItem['di_id'], 'LRTR', maxSeqNum + 1, { "term_seq_num": maxSeqNum + 2 }];
    //console.log(req_obj);

    try {
      let resp = await this.main.addData(req_obj);

      if (!resp['error']) {
        Swal.fire('Success!', 'Term has been attached successfully.', 'success');

        this.phytermsarr[node.id] = []

        node.showTerms = false;
        await this.toggleTermslr(node)
        this.selectedItem = {};

      } else {
        Swal.fire('Error!', 'Failed to insert node.', 'error');
      }
    } catch (error) {
      //console.error('Error inserting node:', error);
      Swal.fire('Error!', 'Failed to insert node.', 'error');
    }
  }

  async insertPf(node) {
    if (node.type !== "application" && node.type !== "Physical File") {
      Swal.fire('Error!', `Attaching Physical File  to ${node.type} is not allowed.`, 'error');
      return;
    }
    else {
      if (node.type == "application") {
        //await this.insertLfPf(node)
        await this.insertPffinal(node)
      }
    }

  }
  async insertLfPf(node) {
    let req_obj = new Object()
    req_obj['pf_path'] = 'dd'
    req_obj['pf_name'] = 'di'
    req_obj['app_cd'] = 'DD'
    req_obj['columns'] = [
      "di_bus_nm",
      "di_tech_nm",
      "di_tcd",
      "di_tcd_json"


    ]
    req_obj['values'] = [
      [
        `${this.selectedItem['di_tech_nm']} logical file`,
        this.selectedItem['di_tech_nm'],
        'LF',
        { "default_lr": { "di_tcd": "LR", "di_tech_nm": this.selectedItem['di_tech_nm'] } }
      ],
      [
        `${this.selectedItem['di_tech_nm']} logical record`,
        this.selectedItem['di_tech_nm'],
        'LR',
        { "lr_type": "REFERENCE", "lr_hist": "NH" }
      ]
    ]
    ////console.log(req_obj);

    try {
      let resp = await this.main.addMultiData(req_obj);

      if (!resp['error']) {


      } else {

        Swal.fire('Error!', 'Failed to insert data.', 'error');
      }
    } catch (error) {

      //console.error('Error inserting node:', error);
      Swal.fire('Error!', 'Failed to insert node.', 'error');
    }



  }
  async insertPffinal(node) {
    let cl_id = await this.getclid(node)
    ////console.log(cl_id);
    let maxcnt = -1
    if (cl_id) {
      maxcnt = await this.getmaxcnt(cl_id)
      ////console.log(maxcnt);
    }
    let req_obj = new Object()
    req_obj['pf_path'] = 'dd'
    req_obj['pf_name'] = 'clxdi'
    req_obj['app_cd'] = 'DD'
    req_obj['columns'] = ['sub_cl_id', 'obj_di_id', 'clxdi_tcd', 'clxdi_seq_num', 'clxdi_tcd_json']
    req_obj['values'] = [cl_id, this.selectedItem['di_id'], 'AVDI', maxcnt + 1, {}]
    ////console.log(req_obj);

    try {
      let resp = await this.main.addData(req_obj);

      if (!resp['error']) {
        await this.updatePf(this.selectedItem, node.cd)

        Swal.fire('Success!', 'PF has been attached successfully.', 'success');
        setTimeout(async () => {
          await this.showFiles({ cl_id: node.cl_id });
          this.selectedItem = {};
          this.selectedtype = null;
          this.showbox = false;
        }, 1000)



        // this.showTermbox = false;
      } else {

        Swal.fire('Error!', 'Failed to insert node.', 'error');
      }
    } catch (error) {

      //console.error('Error inserting node:', error);
      Swal.fire('Error!', 'Failed to insert node.', 'error');
    }
  }
  async updatePf(item, pf_path) {
    item['di_tcd_json']['pf_path'] = pf_path.toLowerCase()
    let updateobj = {}
    updateobj['di_tcd'] = item['di_tcd']
    updateobj['di_tcd_json'] = item['di_tcd_json']

    let where: any = {}

    where['di_id'] = item['di_id']

    this.main.updateData({ pf_path: 'dd', pf_name: 'di', app_cd: 'DD', set: updateobj, where: where }).then(response => {
    }).catch(error => {
      //console.error('Error updating data:', error);
    });


  }
  async deletepf(node) {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: `You are about to Remove ${node.cd} from the app ${this.config?.['cl_val']}`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, remove  it!'
    });


    if (result.isConfirmed) {
      await this.finaldeletepf(node)

    }

  }
  async finaldeletepf(node) {
    //console.log(node, this.config);
    let where: any = {
      "and": [
        {
          clxdi_id: node['referData']?.[`${this.main.act_id}_dd-clxdi`]['clxdi_id']
        }
      ]
    };

    let req_obj = {
      pf_path: 'dd',
      pf_name: 'clxdi',
      app_cd: 'DD',
      where: where
    };

    try {
      //console.log(req_obj);

      const resp = await this.main.deleteData(req_obj);
      //console.log(resp);


      if (!resp.error) {
        await this.updatePf(node['referData'], 'DEFAULT')

        Swal.fire('Deleted!', 'PF has been removed from the file', 'success');
        await this.showFiles({ cl_id: node.cl_id });

      } else {

        Swal.fire('Error!', 'Failed to remove pf', 'error');
      }
    } catch (error) {

      //console.error('Error remove pf:', error);
      Swal.fire('Error!', 'Failed to remove pf.', 'error');
    }
  }
  async getmaxcnt(cl_id) {
    let where: any = {
      "and": [
        {
          "sub_cl_id": {
            "=": cl_id
          }
        }
      ]
    };

    let req_obj = {
      pf_path: 'dd',
      pf_name: 'clxdi',
      app_cd: 'DD',
      filter: where,
      "include": {
        "all": true
      }



    }
    try {
      const resp = await this.main.getListData(req_obj);
      ////console.log(resp);
      if (!resp.error) {
        let maxSeqNum = -1;

        if (resp['data'].length > 0) {
          for (const objDi of resp['data']) {
            const dixdiSeqNum = objDi['clxdi_seq_num'];
            if (dixdiSeqNum && dixdiSeqNum > maxSeqNum) {
              maxSeqNum = dixdiSeqNum;
            }
          }
          return maxSeqNum;

        }
        return maxSeqNum;
      } else {

        Swal.fire('Error!', 'error', 'error');
        return -1;
      }
    } catch (error) {

      //console.error('Error', error);
      Swal.fire('Error!', 'Failed to get data.', 'error');
      return -1;
    }
  }
  async getclid(node) {
    let where: any = {
      "and": [
        {
          "di_tcd": {
            "=": "TR"
          }
        },
        {
          "di_tech_nm": {
            "=": "app_cd"
          }
        }
      ]
    };

    let req_obj = {
      pf_path: 'dd',
      pf_name: 'di',
      app_cd: 'DD',
      filter: where,
      "include": {
        "all": true
      }
    }
    try {
      const resp = await this.main.getListData(req_obj);
      ////console.log(resp);
      if (!resp.error) {
        let clarr = resp['data'][0]['cl'];
        let clid;
        clarr.forEach(async (cl) => {


          if (node.cd == cl.cl_cd) {
            ////console.log(node.id, cl.cl_cd, cl.cl_id);
            clid = cl.cl_id
          }
        })
        return clid;
        // Swal.fire('Deleted!', 'Node has been deleted.', 'success');
      } else {

        Swal.fire('Error!', 'error', 'error');
      }
    } catch (error) {

      //console.error('Error', error);
      Swal.fire('Error!', 'Failed to get data.', 'error');
    }
  }
  showbox = false;
  async getItems(type) {
    if (type == 'APP') {
    }
    else {
      await this.getData({ 'di_tcd': type })

    }
    this.showbox = true;

  }
  isSelectedItemNotEmpty(): boolean {
    return Object.keys(this.selectedItem).length > 0;
  }
  async removeUnique(node) {
    let indexes = this.pfnode['referData']?.['di_tcd_json']?.['indexes'];
    if (indexes) {
      for (let i = 0; i < indexes.length; i++) {
        if (indexes[i].unique && indexes[i].idx_keys.includes(node['di_tech_nm'])) {
          let keyIndex = indexes[i].idx_keys.indexOf(node['di_tech_nm']);
          if (keyIndex !== -1) {
            indexes[i].idx_keys.splice(keyIndex, 1);
            if (indexes[i].idx_keys.length === 0) {
              indexes.splice(i, 1);
            }
            await this.updatedi();
            return true;
          }
        }
      }
    }
    return false;
  }

  async removeIndex(node) {
    let indexes = this.pfnode['referData']?.['di_tcd_json']?.['indexes'];
    if (indexes) {
      for (let i = 0; i < indexes.length; i++) {
        if (!indexes[i].unique && indexes[i].idx_keys.includes(node['di_tech_nm'])) {
          let keyIndex = indexes[i].idx_keys.indexOf(node['di_tech_nm']);
          if (keyIndex !== -1) {
            indexes[i].idx_keys.splice(keyIndex, 1);
            if (indexes[i].idx_keys.length === 0 && !indexes[i].unique) {
              indexes.splice(i, 1);
            }
            await this.updatedi();
            return true;
          }
        }
      }
    }
    return false;
  }

  async removeisPrimary(node) {
    let pkobj = this.pfnode['referData']?.['di_tcd_json']?.['primary_key'];
    if (pkobj && pkobj.pk_keys.includes(node['di_tech_nm'])) {
      let keyIndex = pkobj.pk_keys.indexOf(node['di_tech_nm']);
      if (keyIndex !== -1) {
        pkobj.pk_keys.splice(keyIndex, 1);
        if (pkobj.pk_keys.length === 0) {
          delete this.pfnode['referData']['di_tcd_json']['primary_key'];
        }
        await this.updatedi();
        return true;
      }
    }
    return false;
  }



  async updatedi() {

    let updateobj = {}
    updateobj['di_tcd'] = 'PF'
    updateobj['di_tcd_json'] = this.pfnode['referData']?.['di_tcd_json']

    let where: any = {}

    where['di_id'] = this.pfnode['referData']?.['di_id']

    this.main.updateData({ pf_path: 'dd', pf_name: 'di', app_cd: 'DD', set: updateobj, where: where }).then(response => {
    }).catch(error => {
      //console.error('Error updating data:', error);
    });


  }
  async finaldelete(node, term) {
    ////console.log(node);
    let where: any = {
      "and": [
        {
          dixdi_id: term?.['1_dd-dixdi']?.['dixdi_id']
        }
      ]
    };

    let req_obj = {
      pf_path: 'dd',
      pf_name: 'dixdi',
      app_cd: 'DD',
      where: where
    };

    try {

      const resp = await this.main.deleteData(req_obj);

      if (!resp.error) {
        await this.removeUnique(term)
        await this.removeisPrimary(term)
        await this.removeIndex(term)

        Swal.fire('Deleted!', 'Term has been removed.', 'success');
        this.phytermsarr[node.id] = []
        node.showTerms = false;
        await this.toggleTermslr(node)


        //await this.showTerms({ id: this.pfId });
      } else {

        Swal.fire('Error!', 'Failed to delete term.', 'error');
      }
    } catch (error) {

      //console.error('Error deleting term', error);
      Swal.fire('Error!', 'Failed to delete term.', 'error');
    }
  }

  async removeNode(node, term): Promise<void> {
    // Show confirmation dialog
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: `You are about to remove the  term ${term.di_bus_nm}  from ${node.label}. This action cannot be undone.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!'
    });
    if (result.isConfirmed) {
      await this.finaldelete(node, term)

    }
  }
  clArr = []
  async getAllDiTcd() {
    this.clArr = []
    let where: any = {
      "and": [


        {
          "di_tech_nm": {
            "=": "di_tcd"
          }
        },
        {
          "di_tcd": {
            "=": "TR"
          }
        }
      ]
    };

    let req_obj = {
      pf_path: 'dd',
      pf_name: 'di',
      app_cd: 'DD',
      filter: where,
      "include": {
        "all": true
      }

    };
    try {

      const resp = await this.main.getListData(req_obj);
      ////console.log(resp);


      if (!resp.error) {
        // this.clArr = resp['data'][0]['cl']

        this.clArr.push({ cl_cd: "TR", cl_val: "Business Term" })

        this.clArr.push({ cl_cd: "PF", cl_val: "Physical File" })
        this.clArr.push({ cl_cd: "RL", cl_val: "Manage Relationship" })

        // this.clArr.push({ cl_cd: "APP", cl_val: "Application" })

        // Swal.fire('Deleted!', 'Node has been deleted.', 'success');
      } else {

        Swal.fire('Error!', 'Failed to get classifications.', 'error');
      }
    } catch (error) {

      //console.error('Error while getting classifications:', error);
      Swal.fire('Error!', 'Failed to get classifications.', 'error');
    }
  }
  filteredItems: any[];
  searchTerm: string;
  applyFilter() {
    ////console.log(this.searchTerm);

    if (!this.searchTerm) {
      this.filteredItems = this.ItemsArr;
      return;
    }

    this.filteredItems = this.ItemsArr.filter(item =>

      item.di_tech_nm.toLowerCase().includes(this.searchTerm.toLowerCase())
      // item.di_bus_nm.toLowerCase().includes(this.searchTerm.toLowerCase())
    );
  }
  ascarr = []
  filterkeyobj: any = {}
  async getAssociations() {
  this.ascarr = [];
  this.filterkeyobj = {};

  const initialFilter = {
    and: [
      {
        di_tcd: { "=": "ASC" }
      }
    ]
  };

  const initialReq = {
    pf_path: 'dd',
    pf_name: 'di',
    app_cd: 'DD',
    filter: initialFilter
  };

  const createValidId = (source, target, label) => {
    const id = `${source}_${target}_${label}`.replace(/[^a-zA-Z0-9-_]/g, '-');
    return `id-${id}`;
  };

  const createEdge = (source, target, label, data, linkid, sourcejson, targetjson) => ({
    id: createValidId(source, target, label),
    source,
    target,
    label,
    data,
    linkid,
    sourcejson,
    targetjson
  });

  try {
    const initialResp = await this.main.getListData(initialReq);
    if (initialResp.error) {
      Swal.fire('Error!', 'Failed to get Associations.', 'error');
      return;
    }

    const associations = [];

    for (const asc of initialResp.data) {
      let relshow = asc?.di_tcd_json?.asc_bi_directional_tcd;
      let linkid = asc.di_id;

      const detailedFilter = {
        and: [
          {
            sub_di_id: { "=": asc.di_id }
          }
        ]
      };

      const detailedReq = {
        pf_path: 'dd',
        pf_name: 'dixdi',
        app_cd: 'DD',
        filter: detailedFilter,
        include: { all: true }
      };

      const detailedResp = await this.main.getListData(detailedReq);
      if (detailedResp.error) continue;

      const data = detailedResp.data;
      if (!data || data.length === 0) continue;

      data.sort((a, b) => a.dixdi_id - b.dixdi_id);

      const isBiDirectional =
        asc?.di_tcd_json?.asc_bi_directional_tcd === 'M-M';

      if (!isBiDirectional) {
        for (const item of data) {
          if (!this.filterkeyobj[item.obj_di_id]) {
            this.filterkeyobj[item.obj_di_id] = [];
          }
        }

        for (let index = 0; index < data.length; index++) {
          if (index === 1) {
            const item = data[index];
            this.filterkeyobj[item.obj_di_id].push(
              item?.dixdi_tcd_json?.foreignKey?.di_tech_nm || item.obj_di_id
            );
          }
        }
      }

      const sourceId = data[0]?.obj_di_id;
      const targetId = data[1]?.obj_di_id || sourceId;

      const assoc = [];
      assoc.push(
        createEdge(
          sourceId,
          targetId,
          relshow,
          'FILETOFILE',
          linkid,
          data[0],
          data[1]
        )
      );

      if (isBiDirectional) {
        const targetNode = await this.getnodeidbyname(
          data[0]?.dixdi_tcd_json?.through?.di_tech_nm
        );

        assoc.push(
          createEdge(
            sourceId,
            targetNode,
            `Foreign Key----> ${data[0]?.dixdi_tcd_json?.foreignKey?.di_tech_nm}`,
            'crossrelation',
            linkid,
            {},
            {}
          )
        );

        for (const item of data) {
          if (!this.filterkeyobj[targetNode]) {
            this.filterkeyobj[targetNode] = [];
          }
        }

        for (const item of data) {
          this.filterkeyobj[targetNode].push(
            item?.dixdi_tcd_json?.foreignKey?.di_tech_nm || item.obj_di_id
          );
        }
      }

      if (data.length > 1 && isBiDirectional) {
        const reverseSourceId = data[1]?.obj_di_id;
        const targetNode = await this.getnodeidbyname(
          data[0]?.dixdi_tcd_json?.through?.di_tech_nm
        );

        assoc.push(
          createEdge(
            reverseSourceId,
            targetNode,
            `Foreign Key----> ${data[1]?.dixdi_tcd_json?.foreignKey?.di_tech_nm}`,
            'crossrelation',
            linkid,
            {},
            {}
          )
        );
      }

      associations.push(...assoc);
    }

    this.ascarr = associations;

  } catch (error) {
    // unchanged
  }
}

  PFSArr = []
  async getMissingDiids() {
    const missingIdsSet = new Set();

    // Loop through ascarr to find missing DIIDs


    this.ascarr.forEach(item => {
      const { source, target } = item;

      const sourceExists = this.distinctDIID.includes(source);
      const targetExists = this.distinctDIID.includes(target);

      // If only source exists but target is missing, add target to missingIdsSet
      if (sourceExists && !targetExists && target !== undefined) {
        missingIdsSet.add(target);
      }
      // If only target exists but source is missing, add source to missingIdsSet
      if (!sourceExists && targetExists && source !== undefined) {
        missingIdsSet.add(source);
      }
    });

    // Convert the Set back to an array
    const missingIds = Array.from(missingIdsSet);
    console.log("Missing DIIDs:", missingIds);

    let req_obj = {
      pf_path: 'dd',
      pf_name: 'di',
      app_cd: 'DD'
    };

    this.PFSArr = [];

    // Using for...of to handle async/await properly
    for (const ele of missingIds) {
      let where = {
        "and": [
          {
            "di_id": {
              "=": ele
            }
          }
        ]
      };

      req_obj['filter'] = where;

      try {
        // Await the API call to fetch data
        const resp = await this.main.getListData(req_obj);
        ////console.log(resp);
        if (!resp.error) {
          if (resp['data'].length > 0) {
            this.PFSArr.push(resp['data'][0]);
          }
        } else {
          await Swal.fire('Error!', 'error', 'error');
        }
      } catch (error) {
        // Handle errors
        await Swal.fire('Error!', 'Failed to get data.', 'error');
      }
    }

    //console.log("PFSArr:", this.PFSArr);
  }


  async getnodeidbyname(technm) {
    let req_obj = new Object()
    ////console.log(technm, 'technm');

    req_obj['di_tech_nm'] = technm;
    req_obj['di_tcd'] = 'PF'
    //  console.log("Request Object:", req_obj);
    let resp = await this.main.getdtls(req_obj)
    if (resp['error'] == false) {
      ////console.log(resp);
      if (resp['data'].length > 0) {
        return resp['data'][0]['di_id']
      }
    }
    else {


      Swal.fire('Error!', 'Failed to get cross pf', 'error');

    }

  }
  async onCheckboxChange(event) {

    ////console.log(event.checked)
    if (event.checked) {
      // await this.showAssociations()
      setTimeout(async () => {
        this.edges = []
        await this.showAssociations()
      }, 1000)
    }
    else {
      await this.removeAssociations()
    }


    // await this.updateFieldVisibility(this.showAdvancedFields);
    // await this.fillModelWithDefaults(this.schema, this.rrvconfig.formData);
  }

  async onAddButtonClick() {
    if (this.selectedtype == 'APP') {
      await this.openDialog()
    }
    else if (this.selectedtype == 'PF') {
      // this.router.navigate(['/pf'])
      let itemObj = window.btoa(JSON.stringify({
        pf_path: 'dd',
        pf_name: 'di',
        app_cd: 'DD',
        header: {
          code: this.selectedtype,
          value: this.di_tcd_obj[this.selectedtype]
        },
        mode: 'create',
        formData: {}
      }))
      this.router.navigate(['./pf'], { relativeTo: this.route.parent, queryParams: { id: itemObj } });
    }
    else if (this.selectedtype == 'TR') {
      // this.router.navigate(['/pf'])
      let itemObj = window.btoa(JSON.stringify({
        pf_path: 'dd',
        pf_name: 'di',
        app_cd: 'DD',
        header: {
          code: this.selectedtype,
          value: this.di_tcd_obj[this.selectedtype]
        },
        mode: 'create',
        formData: {}
      }))
      this.router.navigate(['./term'], { relativeTo: this.route.parent, queryParams: { id: itemObj } });
    }
    else {
      await this.rrvConfig('create', {})
    }


  }
  async update(path, node, mode) {

    if (path == 'PF') {
      ////console.log(node);
      let logicalrecord = {}
      let copyObj = { ...node['referData'] }
      if (copyObj['1_clxdi'])
        delete copyObj['1_clxdi']
      if (copyObj['logical_file'])
        delete copyObj['logical_file']
      this.hierarchicalData.forEach(async application => {
        application['data_files'].forEach(async (file: any) => {
          if (file['di_id'] == node['id']) {
            file['logical_file'].forEach(async (ele) => {
              if (ele['di_tech_nm'] == file?.['di_tcd_json']?.['default_lf']?.['di_tech_nm']) {
                ele['logical_record'].forEach(async (lr) => {
                  if (lr['di_tech_nm'] == ele?.['di_tcd_json']?.['default_lr']?.['di_tech_nm'])
                    logicalrecord = lr
                })


              }
            })
          }
        })
      })
      copyObj['lrobj'] = logicalrecord
      let itemObj = window.btoa(JSON.stringify({
        pf_path: 'dd',
        pf_name: 'di',
        app_cd: 'DD',
        header: {
          code: this.selectedtype,
          value: this.di_tcd_obj[this.selectedtype]
        },
        mode: mode,
        formData: copyObj
      }))
      this.router.navigate(['./pf'], { relativeTo: this.route.parent, queryParams: { id: itemObj } });
    }
    if (path == 'TR') {
      ////console.log(node);
      let copyObj = { ...node }
      let itemObj = window.btoa(JSON.stringify({
        pf_path: 'dd',
        pf_name: 'di',
        app_cd: 'DD',
        header: {
          code: this.selectedtype,
          value: this.di_tcd_obj[this.selectedtype]
        },
        mode: mode,
        formData: copyObj
      }))
      this.router.navigate(['./term'], { relativeTo: this.route.parent, queryParams: { id: itemObj } });
    }
  }
  async rrvConfig(mode: any, formData: any) {
    let itemObj = window.btoa(JSON.stringify({
      pf_path: 'dd',
      pf_name: 'di',
      app_cd: 'DD',
      header: {
        code: this.selectedtype,
        value: this.di_tcd_obj[this.selectedtype]
      },
      mode: mode,
      formData: formData
    }))
    this.router.navigate(['./rrv'], { relativeTo: this.route.parent, queryParams: { id: itemObj } });
  }
  async openDialog() {
    const dialogRef = this.dialog.open(AppDetailsModalComponent, {
      width: '400px',
      data: {}
    });

    dialogRef.afterClosed().subscribe(async result => {
      ////console.log('The dialog was closed', result);
      await this.insertApp(result)

    });
  }
  async insertApp(data) {
    let columns = ['di_id', 'cl_cd'];

    let values = [this.app_id, data['cl_cd']];


    if (data['cl_val']) {
      columns.push('cl_val');
      values.push(data['cl_val']);
    }
    if (data['cl_desc']) {
      columns.push('cl_desc');
      values.push(data['cl_desc']);
    }
    if (data['cl_tcd_json']) {
      columns.push('cl_tcd_json');
      values.push(data['cl_tcd_json']);
    }

    let req_obj = {
      pf_path: 'dd',
      pf_name: 'cl',
      app_cd: 'DD',
      columns: columns,
      values: values
    };
    try {
      let resp = await this.main.addData(req_obj);

      if (!resp['error']) {
        await this.getAllApplications()

        Swal.fire('Success!', 'APP has been added successfully.', 'success');
      } else {

        Swal.fire('Error!', 'Failed to  add app.', 'error');
      }
    } catch (error) {

      //console.error('Error adding app:', error);
      Swal.fire('Error!', 'Failed to  add app.', 'error');
    }


  }

  openMenu(menu: any) {
    this.renderer.addClass(menu.panel.nativeElement, 'mat-menu-panel');
    menu.openMenu();

  }

  addPrimaryKey(node: any) {


  }

  addUniqueKey(node: any) {

  }
  keyflag = false


  showTermCheckboxes() {

  }
  selectedTerms = [];
  toggleTermSelection(nodeId: number) {
    const index = this.selectedTerms.indexOf(nodeId);
    if (index !== -1) {
      this.selectedTerms.splice(index, 1);
    } else {
      this.selectedTerms.push(nodeId);
    }
  }

  isSelected(nodeId: number): boolean {
    return this.selectedTerms.includes(nodeId);
  }
  phynode = {}
  key: any
  addKey(node, key) {
    this.keyflag = true
    this.phynode = node
    this.key = key
  }
  async onSave() {
    ////console.log(this.selectedTerms);
    switch (this.key) {
      case 'primary_key': await this.setPrimarykey()
    }


  }
  async setPrimarykey() {
    ////console.log(this.phynode['referData']);
    this.phynode['referData']['di_tcd_json'].primary_key = {
      auto_increment: true,
      pk_keys: this.selectedTerms
    };
    let updateobj = {}
    updateobj['di_tcd_json'] = JSON.stringify(this.phynode['referData']['di_tcd_json'])

    let where: any = {}

    where['di_id'] = this.phynode['referData']['di_id']

    this.main.updateData({ pf_path: 'dd', pf_name: 'di', app_cd: 'DD', set: updateobj, where: where }).then(response => {
      //////console.log('Data added successfully:', response);
      this.showTerms(this.phynode)
      this.keyflag = false;
      this.selectedTerms = []

      Swal.fire({
        title: 'Success!',
        text: 'Primary Key Added successfully!',
        icon: 'success',
        confirmButtonColor: '#4caf50',
        confirmButtonText: 'OK',
      });



    }).catch(error => {
      //console.error('Error updating data:', error);
    });



  }
  async isPrimary(node, term) {

    // ////console.log(node);

    let pkobj = node['referData']?.['di_tcd_json']?.['primary_key']
    // //console.log(pkobj);

    if (pkobj) {

      if (pkobj.pk_keys.includes(term)) {
        return true
      }
      else {
        return false
      }

    }
    else {
      return false
    }

  }
  async isUnique(node, term) {
    let indexes = node['referData']?.['di_tcd_json']?.['indexes'];
    if (indexes) {
      for (let index of indexes) {
        if (index.unique && index.idx_keys.includes(term)) {
          return true;
        }
      }
    }

    return false;

  }
  async isIndex(node, term) {
    let indexes = node['referData']?.['di_tcd_json']?.['indexes'];
    if (indexes) {
      for (let index of indexes) {
        if (!index.unique && index.idx_keys.includes(term)) {
          return true;
        }
      }
    }

    return false;

  }

  async initializeApp(node: any) {
    await this.finalinitialize(node)





  }
  async finalinitialize(node) {
    let req_obj = new Object()
    req_obj['app_cd'] = node['cd']
    req_obj['clear'] = true,
      req_obj['reload'] = false
    try {

      const resp = await this.main.initializeApp(req_obj);

      if (!resp.error) {


        Swal.fire('Info!', 'App initialized successfully.', 'success');



      } else {

        Swal.fire('Error!', 'Failed to initialize App', 'error');
      }
    } catch (error) {

      //console.error('Error initialize App', error);
      Swal.fire('Error!', 'Failed to initialize App', 'error');
    }

  }

  stopApp(node: any): void {

    Swal.fire('Info!', 'App stopped successfully.', 'info');
  }

  modify(node: any): void {

    Swal.fire('Info!', 'App modified successfully.', 'info');
  }

  visit(node: any): void {

    Swal.fire('Info!', 'Visiting app.', 'info');
  }
  async goback() {
    this.location.back()
  }
  phytermsarr = {}
  async toggleTermsVisibility(node: any): Promise<void> {
    this.phytermsarr[node.id] = []
    if (node['type'] == 'Physical File')
      await this.toggleTerms(node)
    else
      await this.toggleTermslr(node)
  }
  async toggleTerms(node) {
  await Promise.all(this.hierarchicalData.map(async (application) => {
    if (application?.['data_files'] && application?.['data_files'].length > 0) {
      await Promise.all(application.data_files.map(async (physicalFile) => {

        if (physicalFile['di_id'] == node.id) {

          this.pfnode = node;
          const logicalFiles = physicalFile?.logical_file;
          if (!Array.isArray(logicalFiles)) {
            console.warn('No logical_file for PF:', physicalFile);
            return;
          }

          await Promise.all(physicalFile['logical_file'].map(async (logicalFile) => {
            let req_obj = {
              di_tech_nm: logicalFile.di_tech_nm,
              di_tcd: 'LR'
            };

            let resp = await this.main.getdtls(req_obj);
            if (resp['error'] == false) {
              let logicalRecord = resp['data'][0];
              this.phytermsarr[node.id] = [];

              // 🔽 ONLY forEach replaced
              for (const term of logicalRecord.objDi) {
                this.phytermsarr[node.id].push(term);
              }

            } else {
              // unchanged
            }
          }));
        }
      }));
    }
  }));

  const terms = this.phytermsarr[node.id];

  const updatedTerms = await Promise.all(
    terms.map(async (ele) => {
      ele['isPrimary'] = await this.isPrimary(node, ele['di_tech_nm']);
      ele['isUnique'] = await this.isUnique(node, ele['di_tech_nm']);
      ele['isIndex'] = await this.isIndex(node, ele['di_tech_nm']);
      ele['isForeign'] = await this.isForeign(node, ele['di_tech_nm']);
      return ele;
    })
  );

  this.phytermsarr[node.id] = updatedTerms
    .filter(ele => ele['isPrimary'] || ele['isUnique'] || ele['isForeign'])
    .sort((a, b) => {
      if (a['isPrimary'] && !b['isPrimary']) return -1;
      if (!a['isPrimary'] && b['isPrimary']) return 1;
      if (a['isUnique'] && !b['isUnique']) return -1;
      if (!a['isUnique'] && b['isUnique']) return 1;
      if (a['isForeign'] && !b['isForeign']) return -1;
      if (!a['isForeign'] && b['isForeign']) return 1;
      return 0;
    });

  if (this.phytermsarr[node.id].length === 0) {
    Swal.fire({
      icon: 'info',
      title: 'No Terms Present',
      text: 'There are no terms present in this Physical file.',
      confirmButtonText: 'OK'
    });
    return;
  }

  node.showTerms = !node.showTerms;
  this.nodes = [...this.nodes];
  this.edges = [...this.edges];
}

  async isForeign(node, techNm) {
    if (this.filterkeyobj.hasOwnProperty(node.id)) {
      if (this.filterkeyobj[node.id].includes(techNm)) {
        return true;
      }
      else {
        return false;
      }
    }
    else {
      return false;
    }

  }

  async toggleTermslr(node) {
    await Promise.all(this.hierarchicalData.map(async (application) => {
      if (application?.['data_files'] && application?.['data_files'].length > 0) {
        await Promise.all(application.data_files.map(async (physicalFile) => {
          if (physicalFile['di_id'] == this.pfId) {
            await Promise.all(physicalFile.logical_file.map(async (logicalFile) => {
              let req_obj = {
                'di_tech_nm': logicalFile.di_tech_nm,
                'di_tcd': 'LR'
              };
              let resp = await this.main.getdtls(req_obj);
              if (resp['error'] == false) {
                //console.log(resp);
                let logicalRecord = resp['data'][0];
                this.termarr = [];
              for (const term of logicalRecord.objDi) {
                  this.phytermsarr[node.id].push(term);
                };

                //this.phytermsarr[node.id].sort((a, b) => a['1_dd-dixdi']['dixdi_seq_num'] - b['1_dd-dixdi']['dixdi_seq_num']);
              } else {

              }
            }));
          }
        }));
      }
    }));
    if (this.phytermsarr[node.id].length === 0) {
      Swal.fire({
        icon: 'info',
        title: 'No Terms Present',
        text: 'There are no terms present in this  Physical file.',
        confirmButtonText: 'OK'
      });
      return
    }
    node.showTerms = !node.showTerms;

    const terms = this.phytermsarr[node.id];
    this.phytermsarr[node.id].map(async (ele) => {
      ele['isPrimary'] = await this.isPrimary(this.pfnode, ele['di_tech_nm']);
      ele['isUnique'] = await this.isUnique(this.pfnode, ele['di_tech_nm']);
      ele['isIndex'] = await this.isIndex(this.pfnode, ele['di_tech_nm']);
      ele['isForeign'] = await this.isForeign(this.pfnode, ele['di_tech_nm']);
    });
    //console.log(node, this.phytermsarr[node.id]);
    this.nodes = [...this.nodes]
    this.edges = [...this.edges]

  }
  truncateLabel(label: string, maxLength: number): string {
    if (label.length > maxLength) {
      return label.slice(0, maxLength) + '...';
    }
    return label;
  }


  calculateSVGHeight(node: any): number {
    // ////console.log(node);

    const termHeight = 35;
    const padding = 10;

    if (this.phytermsarr[node.id].length == 0)
      return 0;
    return ((this.phytermsarr[node.id].length) * termHeight) + padding;
  }
  mainpfnode = {}
  async addterms(node) {
    ////console.log(node);
    this.mainpfnode = node;
    this.selectedtype = null;
    this.selectedcl = null;
    this.searchTerm = null
    this.filteredItems = []


    await this.removenodesexceptpf()
    await this.removeedge()
    await this.getlogicalrecord(node)



  }
  async removenodesexceptpf() {
    this.nodes = []
    this.nodes = [...this.nodes]

  }
  async removeedge() {
    this.edges = []
    this.edges = [...this.edges]

  }
  pfflag = false;
  lrnode = {}
  async getlogicalrecord(node) {
  for (const application of this.hierarchicalData) {
    if (application?.['data_files'] && application?.['data_files'].length > 0) {

      for (const physicalFile of application.data_files) {
        if (physicalFile['di_id'] == node.id) {
          this.pfId = node.id;
          this.pfnode = node;
          this.pfflag = true;

          for (const logicalFile of physicalFile.logical_file) {
            let req_obj = new Object();
            req_obj['di_tech_nm'] = logicalFile.di_tech_nm;
            req_obj['di_tcd'] = 'LR';

            let resp = await this.main.getdtls(req_obj);
            if (resp['error'] == false) {
              //console.log(resp);
              let logicalRecord = resp['data'][0];
              this.lrnode = logicalRecord;
              this.termarr = [];

              this.nodes.push({
                id: `${logicalRecord.di_id}`,
                label: logicalRecord.di_bus_nm,
                type: 'Logical Record',
                referData: logicalRecord
              });

              this.nodes = [...this.nodes];
              this.phytermsarr[logicalRecord.di_id] = [];
              this.nodes[0].showTerms = true;

              await this.toggleTermslr({
                id: `${logicalRecord.di_id}`,
                label: logicalRecord.di_bus_nm,
                type: 'Logical Record',
                referData: logicalRecord
              });
            } else {
              Swal.fire('Error!', 'error', 'error');
            }
          }
        }
      }
    }
  }
}

  // async gobacktopfs() {
  //   this.selectedtype = null;
  //   this.selectedcl = null;
  //   this.searchTerm = null;
  //   this.filteredItems = []
  //   this.showbox = false
  //   await this.removenodesexceptpf()
  //   await this.removeedge()
  //   await this.constructappnode(this.config)

  //   this.pfflag = false;
  //   await this.getAllApplications()


  //   await this.getAllDiTcd()
  //   await this.getAssociations()

  // }
  async gobacktopfs() {
  this.spinner.show();

  try {
    this.selectedtype = null;
    this.selectedcl = null;
    this.searchTerm = null;
    this.filteredItems = [];
    this.showbox = false;

    await this.reset(); // 🔴 important – same as ngOnInit

    await this.constructappnode(this.config);
    this.pfflag = false;

    await this.getAllDiTcd();
    await this.getAssociations();

    await this.getAllApplications();
    await this.showAssociations();

  } catch (err) {
    console.error('Error in gobacktopfs', err);
  } finally {
    this.spinner.hide();
  }
}

  async delete(node, term) {
    ////console.log(term);
    await this.removeNode(node, term)


  }
  onDropasc(event: CdkDragDrop<any>, targetNode: Node) {
    ////console.log(event, targetNode);

    const draggedNode: Node = event.item.data;
    if (draggedNode && draggedNode !== targetNode) {
      ////console.log(`Dropped ${draggedNode} onto ${targetNode}`);

    }
  }

  onDragEndasc(event: CdkDragEnd, node: Node) {
    ////console.log(node, event);

    const { x, y } = event.distance;
    // node.x += x;
    // node.y += y;
    const dropX = event['clientX'];
    const dropY = event['clientY'];

    let nodefound = false
    for (const node of this.nodes) {

      const nodeElement = document.getElementById(node.id);
      const nodeRect = nodeElement.getBoundingClientRect();
      const nodeX = nodeRect.left + window.scrollX;
      const nodeY = nodeRect.top + window.scrollY;


      if (dropX >= nodeX && dropX <= nodeX + nodeRect.width &&
        dropY >= nodeY && dropY <= nodeY + nodeRect.height) {
        ////console.log(event);

        ////console.log('Item dropped on node:', node);
      }
    }
  }
  startNode
  onNodeCircleMouseDown(event, node) {
    ////console.log(event, node);
    this.startNode = node;
  }

  onGlobalMouseUp(event: MouseEvent): void {
    // ////console.log(event);
    event.preventDefault();
    // ////console.log(event);
    const dropX = event.clientX;
    const dropY = event.clientY;
    let modal = false;


    for (const node of this.nodes) {
      const nodeElement = document.getElementById(node.id);

      if (!nodeElement) {
        // console.warn(`Node element with id ${node.id} not found.`);
        continue; // Skip this iteration if the element is not found
      }

      const nodeRect = nodeElement.getBoundingClientRect();
      const nodeX = nodeRect.left + window.scrollX;
      const nodeY = nodeRect.top + window.scrollY;

      // Check if the drop coordinates are within this node's bounds
      if (dropX >= nodeX && dropX <= nodeX + nodeRect.width &&
        dropY >= nodeY && dropY <= nodeY + nodeRect.height &&
        node['id'] != this.startNode['id'] && this.startNode['id'] && node['id'] && !this.pfflag) {
        console.log('Item dropped on node:', node);
        if (this.isModalVisible) {
          console.log("A modal is already open. Cannot open another one.");
          return; // Exit the function if a modal is already open
        }
        modal = true;
        this.openModal(node);
      }
    }

    if (modal == false) {
      // this.startNode = {}
    }




  }
  isModalVisible: boolean = false;
  selectedNode: Node | null = null;
  targetNode = {};
  relationshipForm: FormGroup;



  relobj: any = {}

  pkarr = []
  fkarr = []
  relarr = [
    {
      code: '1-M',
      value: 'One To Many'
    },
    {
      code: '1-1',
      value: 'One To One'
    },
    {
      code: 'M-M',
      value: 'Many To Many'
    }
  ];

  crossfkar = []
  async getcolumns(crosspf: any) {
    const item = this.pfs.find(item => item.di_tech_nm === crosspf);
    this.crossfkar = item?.logical_file?.[0]?.logical_record?.[0]?.objDi;
    console.log(item, this.crossfkar);

  }

  async addPrimaryAndForeignKey(node: any) {
    console.log(this.startNode, node);
    this.targetNode = node;

    this.pkarr = this.startNode?.referData?.di_tcd_json?.primary_key?.pk_keys || [];
    this.relobj = {
      name: this.startNode.cd,
      nameb: node.cd,
      primary_key: this.pkarr[0],
      rel: '1-M',
    };

    this.fkarr = node?.referData?.logical_file?.[0]?.logical_record?.[0]?.objDi;
  }

  async openModal(node: any) {
    await this.addPrimaryAndForeignKey(node);
    this.isModalVisible = true;
  }

  closeModal(): void {
    this.isModalVisible = false;
    this.startNode = {};
    this.targetNode = {};
    this.nodes = [...this.nodes];
  }

  async submitRelationship() {
    if (!this.validateForm()) return;
    await this.insertAscIndi();
  }

  validateForm(): boolean {
    console.log(this.relobj);

    const { primary_key, rel, foreign_key, cross_pf, fkenta, fkentb, name, nameb } = this.relobj;

    if (!primary_key) {
      Swal.fire('Validation Error', 'Primary Key is required.', 'error');
      return false;
    }
    if (!rel) {
      Swal.fire('Validation Error', 'Relationship Type is required.', 'error');
      return false;
    }

    if (rel !== 'M-M') {
      if (!foreign_key) {
        Swal.fire('Validation Error', 'Foreign Key is required for the selected relationship type.', 'error');
        return false;
      }
    } else {
      const pkarr = this.targetNode?.['referData']?.['di_tcd_json']?.['primary_key']?.['pk_keys']
      this.relobj.primary_keyb = pkarr?.[0];

      if (!cross_pf || !fkenta || !fkentb) {
        const missingKey = !cross_pf ? 'Cross-reference table' : !fkenta ? `Foreign key column for ${name}` : `Foreign key column for ${nameb}`;
        Swal.fire('Validation Error', `${missingKey} is required.`, 'error');
        return false;
      }
    }

    return true;
  }

  async insertAscIndi() {
    const reqObj = {
      pf_path: 'dd',
      pf_name: 'di',
      app_cd: 'DD',
      columns: ['di_cd', 'di_bus_nm', 'di_tech_nm', 'di_tcd', 'di_tcd_json'],
      values: [
        `SVM-ASC-${this.relobj.name}${this.relobj.nameb}`,
        `${this.relobj.name} ${this.relobj.rel} association with ${this.relobj.nameb}`,
        `${this.relobj.name}${this.relobj.nameb}`,
        'ASC',
        { asc_bi_directional_tcd: `${this.relobj.rel}` },
      ],
    };

    try {
      const resp = await this.main.addData(reqObj);
      if (!resp.error) {
        await this.insertAscIndiDetails(resp.data.di_id);
      } else {
        Swal.fire('Error!', 'Failed to Add association.', 'error');
      }
    } catch (error) {
      Swal.fire('Error!', 'Failed to Add association.', 'error');
    }
  }

  async createJsons(relobj: any, startnode: any, targetnode: any) {
    let json1, json2;

    const commonJson = {
      foreignKey: { di_tcd: 'TR', di_tech_nm: relobj.foreign_key },
      sourceKey: { di_tcd: 'TR', di_tech_nm: relobj.primary_key },
    };

    switch (relobj.rel) {
      case '1-1':
        json1 = { ...commonJson, seq_num: 1, includes_as: `ref${targetnode.cd}`, asc_tcd: 'HasOne' };
        json2 = { ...commonJson, seq_num: 2, includes_as: `ref${startnode.cd}`, asc_tcd: 'BelongsTo', targetKey: { di_tcd: 'TR', di_tech_nm: relobj.primary_key } };
        break;

      case '1-M':
        json1 = { ...commonJson, seq_num: 1, includes_as: `ref${targetnode.cd}`, asc_tcd: 'HasMany' };
        json2 = { ...commonJson, seq_num: 2, includes_as: `ref${startnode.cd}`, asc_tcd: 'BelongsTo', targetKey: { di_tcd: 'TR', di_tech_nm: relobj.primary_key } };
        break;

      case 'M-M':
        json1 = {
          foreignKey: { di_tcd: 'TR', di_tech_nm: relobj.fkenta },
          sourceKey: { di_tcd: 'TR', di_tech_nm: relobj.primary_key },
          seq_num: 1,
          includes_as: `obj${targetnode.cd}`,
          asc_tcd: 'BelongsToMany',
          through: { di_tcd: 'PF', di_tech_nm: relobj.cross_pf },
          otherKey: { di_tcd: 'TR', di_tech_nm: relobj.fkentb },
          targetKey: { di_tcd: 'TR', di_tech_nm: relobj.primary_keyb },
        };
        json2 = {
          foreignKey: { di_tcd: 'TR', di_tech_nm: relobj.fkentb },
          sourceKey: { di_tcd: 'TR', di_tech_nm: relobj.primary_keyb },
          seq_num: 2,
          includes_as: `sub${startnode.cd}`,
          asc_tcd: 'BelongsToMany',
          through: { di_tcd: 'PF', di_tech_nm: relobj.cross_pf },
          otherKey: { di_tcd: 'TR', di_tech_nm: relobj.fkenta },
          targetKey: { di_tcd: 'TR', di_tech_nm: relobj.primary_key }


        };
        break;

      default:
        return null;
    }

    return [json1, json2];
  }
  async selfreference(node: any) {
    console.log(node)
    this.startNode = node;
    this.openModal(node)

  }

  async insertAscIndiDetails(di_id: any) {
    const json = await this.createJsons(this.relobj, this.startNode, this.targetNode);
    const valArr = [
      [di_id, this.startNode.id, 'ASCPF', 0, json[0]],
      [di_id, this.targetNode['id'], 'ASCPF', 1, json[1]],
    ];

    const reqObj = {
      pf_path: 'dd',
      pf_name: 'dixdi',
      app_cd: 'DD',
      columns: ['sub_di_id', 'obj_di_id', 'dixdi_tcd', 'dixdi_seq_num', 'dixdi_tcd_json'],
      values: valArr,
    };

    try {
      this.spinner.show();
      const resp = await this.main.addMultiData(reqObj);

      if (!resp.error) {
        await this.resetState();
        Swal.fire('Success!', 'Associations created Successfully', 'success');
      } else {
        Swal.fire('Error!', 'Failed to create Associations.', 'error');
      }
    } catch (error) {
      Swal.fire('Error!', 'Failed to create Associations.', 'error');
    } finally {
      this.spinner.hide();
    }
  }

  async resetState() {
    this.relobj = {};
    this.startNode = {};
    this.targetNode = {};
    this.nodes = [...this.nodes];
    this.getAllApplications();
    this.getAssociations();
    await this.closeModal();
    setTimeout(async () => {
      this.edges = [];
      await this.showAssociations();

    }, 1000);
  }





  async updateRelationship() {
    if (!this.validateForm()) {
      return;
    }
    await this.updateascindi()
  }
  async updateascindi() {

    let req_obj = new Object()
    req_obj['pf_path'] = 'dd'
    req_obj['pf_name'] = 'di'
    req_obj['app_cd'] = 'DD'
    let updateobj = {};
    updateobj['di_cd'] = `SVM-ASC-${this.relobj['name']}${this.relobj['nameb']}`;
    updateobj['di_bus_nm'] = `${this.relobj['name']} ${this.relobj['rel']} association with ${this.relobj['nameb']}`;
    updateobj['di_tech_nm'] = `${this.relobj['name']}${this.relobj['nameb']}`;
    updateobj['di_tcd'] = 'ASC';
    updateobj['di_tcd_json'] = { "asc_bi_directional_tcd": `${this.relobj['rel']}` };
    req_obj['set'] = updateobj

    let where: any = {}

    where['di_id'] = this.linkid
    req_obj['where'] = where


    //console.log(req_obj);

    try {
      let resp = await this.main.updateData(req_obj);

      if (!resp['error']) {

        //console.log(resp);
        await this.updateascindidi()


      } else {

        Swal.fire('Error!', 'Failed to Add association.', 'error');
      }
    } catch (error) {

      //console.error(' Failed to Add association:', error);
      Swal.fire('Error!', ' Failed to Add association', 'error');
    }



  }
  async updateascindidi() {
    try {
      let json = await this.createJsons(this.relobj, this.startNode, this.targetNode);
      //console.log(json);

      let valarr = [
        [
          this.linkid,
          this.startNode['id'],
          "ASCPF",
          0,
          json[0]
        ],
        [
          this.linkid,
          this.targetNode['id'],
          "ASCPF",
          1,
          json[1]
        ]
      ];


      for (let i = 0; i < valarr.length; i++) {
        let updateobj = {};
        updateobj['sub_di_id'] = valarr[i][0];
        updateobj['obj_di_id'] = valarr[i][1];
        updateobj['dixdi_tcd'] = valarr[i][2];
        updateobj['dixdi_seq_num'] = valarr[i][3];
        updateobj['dixdi_tcd_json'] = valarr[i][4];

        let where = {};
        where['sub_di_id'] = valarr[i][0];
        where['obj_di_id'] = valarr[i][1];


        let req_obj = {
          pf_path: 'dd',
          pf_name: 'dixdi',
          app_cd: 'DD',
          set: updateobj,
          where: where
        };

        //console.log(req_obj);

        this.spinner.show();

        try {
          let resp = await this.main.updateData(req_obj);
          if (resp['error']) {
            this.spinner.hide();
            Swal.fire('Error!', 'Failed to update associations', 'error');
            return;
          }
        } catch (error) {
          this.spinner.hide();
          //console.error('Error updating associations', error);
          Swal.fire('Error!', 'Failed to update associations', 'error');
          return;
        }
      }


      this.relobj = {};
      this.startNode = {};
      this.targetNode = {};
      this.spinner.hide();
      await this.getAssociations();
      setTimeout(async () => {
        this.edges = [];
        this.startNode = {}
        this.targetNode = {}
        this.modalup = false;
        this.relobj = {}
        await this.getAllApplications()
        await this.showAssociations();
        await this.closeModal();
        Swal.fire('Success!', 'Associations updated successfully', 'success');
      }, 1000);

    } catch (error) {
      this.spinner.hide();
      //console.error('Error creating JSONs', error);
      Swal.fire('Error!', 'Failed to create JSONs', 'error');
    }
  }



  selectedEdge: any = null;

  selectEdge(edge: any) {
    this.selectedEdge = edge;
  }

  removeEdge() {
    if (this.selectedEdge) {
      this.edges = this.edges.filter(edge => edge.id !== this.selectedEdge.id);
      this.selectedEdge = null;
    }
  }

  updateEdge(updatedLabel: string) {
    if (this.selectedEdge) {
      this.selectedEdge.label = updatedLabel;
    }
  }

  async deleteasc(link: any) {
    //console.log(link);
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: `Do you want to remove this association`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, remove it!'
    });


    if (result.isConfirmed) {
      await this.finaldeleteasc(link)

    }


  }
  async finaldeleteasc(link: any) {
    let where: any = {
      "and": [
        {
          sub_di_id: link['linkid']
        }
      ]
    };

    let req_obj = {
      pf_path: 'dd',
      pf_name: 'dixdi',
      app_cd: 'DD',
      where: where
    };

    try {

      const resp = await this.main.deleteData(req_obj);

      if (!resp.error) {
        await this.deleteascmain(link)

        // Swal.fire('Deleted!', 'Association has been deleted.', 'success');

      } else {

        Swal.fire('Error!', 'Failed to delete Association.', 'error');
      }
    } catch (error) {

      //console.error('Error deleting Association:', error);
      Swal.fire('Error!', 'Failed to delete Association.', 'error');
    }

  }
  async deleteascmain(link: any) {
    let where: any = {
      "and": [
        {
          di_id: link['linkid']
        }
      ]
    };

    let req_obj = {
      pf_path: 'dd',
      pf_name: 'di',
      app_cd: 'DD',
      where: where
    };

    try {

      const resp = await this.main.deleteData(req_obj);

      if (!resp.error) {
        await this.getAllApplications()
        await this.getAssociations()

        setTimeout(async () => {
          this.edges = []
          await this.showAssociations()
        }, 1000)
        Swal.fire('Deleted!', 'Association has been deleted.', 'success');

      } else {

        Swal.fire('Error!', 'Failed to delete Association.', 'error');
      }
    } catch (error) {

      //console.error('Error deleting Association:', error);
      Swal.fire('Error!', 'Failed to delete Association.', 'error');
    }

  }
  linkid
  async updateasc(link) {
    //console.log(this.nodes, link);
    this.linkid = link['linkid']

    this.startNode = await (async () => {
      for (const ele of this.nodes) {
        if (ele.id === link['source']) {
          return ele;
        }
      }
    })();

    this.targetNode = await (async () => {
      for (const ele of this.nodes) {
        if (ele.id === link['target']) {
          return ele;
        }
      }
    })();

    //console.log(this.startNode, this.targetNode);

    await this.setModaldata(link);
  }


  modalup = false;
  async setModaldata(link) {
    this.pkarr = this.startNode['referData']?.['di_tcd_json']?.['primary_key']?.['pk_keys']
    //console.log(this.pkarr);
    this.relobj['name'] = this.startNode['cd']
    this.relobj['nameb'] = this.targetNode['cd']
    this.relobj['primary_key'] = this.pkarr[0]
    this.relobj['rel'] = link['label']
    this.fkarr = this.targetNode['referData']?.['logical_file'][0]?.['logical_record'][0]?.['objDi']
    if (this.relobj['rel'] != 'M-M') {
      this.relobj['foreign_key'] = link['sourcejson']?.['dixdi_tcd_json']?.['foreignKey']?.['di_tech_nm']
    }
    else {
      this.relobj['cross_pf'] = link['sourcejson']?.['dixdi_tcd_json']?.['through']?.['di_tech_nm']
      this.relobj['fkenta'] = link['sourcejson']?.['dixdi_tcd_json']?.['foreignKey']?.['di_tech_nm']
      this.relobj['fkentb'] = link['targetjson']?.['dixdi_tcd_json']?.['foreignKey']?.['di_tech_nm']
    }
    this.isModalVisible = true;
    this.modalup = true;

  }
  async deleteterm(item) {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: `Do you want to Delete this Term`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!'
    });


    if (result.isConfirmed) {
      await this.finaldeleteterm(item)

    }


  }
  async finaldeleteterm(item) {
    let where: any = {
      "and": [
        {
          di_id: item['di_id']
        }
      ]
    };

    let req_obj = {
      pf_path: 'dd',
      pf_name: 'di',
      app_cd: 'DD',
      where: where
    };

    try {

      const resp = await this.main.deleteData(req_obj);

      if (!resp.error) {


        Swal.fire('Deleted!', 'Term has been deleted.', 'success');

      } else {

        Swal.fire('Error!', 'Failed to delete Term.', 'error');
      }
    } catch (error) {

      //console.error('Error deleting Term:', error);
      Swal.fire('Error!', 'Failed to delete Term.', 'error');
    }

  }
  pathColorMap: { [key: string]: string } = {};
  colorPalette: string[] = [
    '#4C5D77',
    '#B03A2E',
    '#337AB7',
    '#B7950B',
    '#6A5ACD',
    '#607D8B',
    '#5B366F',
    '#4A90E2'
  ];



  nextColorIndex = 0;


  getColorForPath(path: string): string {
    if (!this.pathColorMap[path]) {
      this.pathColorMap[path] = this.colorPalette[this.nextColorIndex];
      this.nextColorIndex = (this.nextColorIndex + 1) % this.colorPalette.length;
    }
    return this.pathColorMap[path];
  }
  selectedcl: any
  filtercl(cl) {
    console.log(cl, this.ItemsArr);
    cl = cl.toLowerCase()
    this.filteredItems = this.ItemsArr.filter(ele => ele.di_tcd_json?.pf_path == cl);


  }


}




















